export const GenderAtBirth = [
  {
    name: 'Yes',
    value: 'yes',
    translate_key: 'journey_gender_birth_yes'
  },
  {
    name: 'No',
    value: 'no',
    translate_key: 'journey_gender_birth_no'
  },
  {
    name: 'Prefer not to say',
    value: 'undisclosed',
    translate_key: 'journey_gender_birth_not_say'
  },
];

export default GenderAtBirth;